<div class="flex flex-col gap-4">
  <div class="flex flex-col gap-2">
    <label class="text-sm font-medium">
      {{ 'measurement.move_stage.field' | translate }}
    </label>
    <p-tree
      [value]="treeNodes"
      selectionMode="single"
      [selection]="selectedNode()"
      (onNodeSelect)="onNodeSelect($event)"
      (onNodeUnselect)="onNodeUnselect($event)"
      styleClass="w-full border-none"
    />
  </div>

  <p class="text-sm text-surface-600 dark:text-surface-400">
    {{ 'measurement.move_stage.currentLocation' | translate: { measurementName: measurement.name, stageName: currentStage()?.name } }}
  </p>

  @if (hasChanged()) {
    <p-message severity="info" styleClass="w-full">
      {{ 'measurement.move_stage.confirmNote' | translate: { stageName: selectedStage()?.name } }}
    </p-message>
  }

  <div class="flex justify-end gap-2 mt-2">
    <p-button
      [label]="'button.cancel' | translate"
      severity="secondary"
      [outlined]="true"
      (onClick)="cancel()"
    />
    <p-button
      [label]="'button.confirm' | translate"
      [disabled]="!hasChanged()"
      (onClick)="confirm()"
    />
  </div>
</div>
